<template>
  <layout-basic>
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            placeholder="Search Partners"
            class="search-box"
            prepend-icon="fa-search"
            v-model="search"
            type="text"
            clearable
            clear-icon="fa-times"
            @click:clear="resetSearch"
            @change="applySearch"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="partner-button-wrapper">
          <v-btn
            color="primary"
            @click.prevent="showCreatePartnerPanel"
            outlined
          >
            <v-icon class="pr-2">fa-plus</v-icon>Add Partner
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="12">
          <v-card flat>
            <v-card-title>
              <div class="flex-grow-1"></div>
            </v-card-title>
            <v-skeleton-loader v-if="loading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
            <v-data-table
              :headers="headers"
              :options.sync="options"
              :server-items-length="serverItemsLength"
              v-show="!loading"
              :items="partners"
            >
              <template v-slot:item.confirmed="{ item }">
                <v-icon v-if="item.confirmed" color="primary">fa-check</v-icon>
                <v-icon v-else color="error">fa-times</v-icon>
              </template>
              <template v-slot:item.id="{ item }">
                <v-btn
                  color="primary"
                  :to="'/partner/tier/' + item.id"
                  @click.prevent="reload()"
                  >Details</v-btn
                >
                <span>&nbsp;</span>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :disabled="item.state == 4"
                      :id="item.id"
                      v-on="on"
                      outlined
                      small
                      color="secondary"
                      @click.prevent="showEditPanel(item.id)"
                    >
                      <v-icon small>fa-pencil-alt</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit User</span>
                </v-tooltip>
                <!-- Suspend button -->
                <v-tooltip bottom v-if="item.state != 4">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      color="error"
                      class="ml-1"
                      outlined
                      small
                      @click.prevent="updateState(item.id, 'suspend')"
                    >
                      <v-icon small>fa fa-ban</v-icon>
                    </v-btn>
                  </template>
                  <span>Suspend Partner</span>
                </v-tooltip>
                <v-tooltip bottom v-else>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      color="error"
                      class="ml-1"
                      outlined
                      small
                      @click.prevent="updateState(item.id, 'active')"
                    >
                      <v-icon small>fa fa-undo</v-icon>
                    </v-btn>
                  </template>
                  <span>Active Partner</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </layout-basic>
</template>

<script>
import { EventBus } from '@/event-bus.js';
import CreatePartner from '@/components/partner/Create';
import EditPartner from '@/components/partner/Edit';
import partnerAPI from '@/api/partner.js';
import LayoutBasic from '@/layouts/PartnerHub';
export default {
  name: 'Tier2Partner',
  components: {
    LayoutBasic,
  },
  data() {
    return {
      headers: [
        { text: 'Partner', value: 'company_name' },
        { text: 'First Name', value: 'first_name', sortable: false },
        { text: 'Surname', value: 'last_name', sortable: false },
        { text: 'Email', value: 'email', sortable: false },
        { text: 'Level', value: 'partner_level' },
        { text: 'Created On', value: 'created_at' },
        { text: 'Last Login', value: 'last_login', sortable: false },
        { text: '', value: 'id', align: 'end', sortable: false },
      ],
      partnerId: this.$route.params.id,
      partners: [],
      search: '',
      searchParams: '',
      pagination: {},
      options: {},
      loading: false,
      confirmDelete: 'Are you sure you wish to delete this user?',
      confirmUpdatePartnerState: 'Are you sure you wish to update state to ',
      successUpdateStateMessage: 'State has been updated Successfully',
    };
  },
  computed: {
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return this.$gf.getQueryString(this.options, this.serverItemsLength);
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  mounted() {
    this.setEventBus();
  },
  watch: {
    options: {
      handler() {
        this.getTier2Partner();
      },
      deep: true,
    },
  },
  methods: {
    applySearch() {
      this.options.page = 1;
      if (this.search != null) {
        this.searchParams =
          '&search=first_name:' +
          this.search +
          ';last_name:' +
          this.search +
          ';company_name:' +
          this.search;
      } else {
        this.searchParams = '';
      }
      this.getTier2Partner();
    },
    resetSearch() {
      this.options.page = 1;
      this.search = '&level=all';
      this.applySearch();
    },

    getTier2Partner() {
      this.loading = true;
      partnerAPI.getPartners(this.params, this.searchParams).then((resp) => {
        this.partners = resp.data.data;
        this.pagination = resp.data.meta.pagination;
        this.loading = false;
      });
    },
    showEditPanel(id) {
      this.$showPanel({
        component: EditPartner,
        props: {
          id: id,
          params: this.params,
        },
        openOn: 'right',
      });
    },
    showCreatePartnerPanel() {
      this.$showPanel({
        component: CreatePartner,
        props: {
          params: this.params,
        },
        openOn: 'right',
      });
    },
    setEventBus() {
      EventBus.$on('USERS_UPDATED', (payload) => {
        this.params = payload;
        this.getTier2Partner();
      });
    },
    reload() {
      location.reload();
    },
    updateState(id, state = '') {
      var confirmUpdatePartnerState =
        this.confirmUpdatePartnerState + state + '?';
      this.$snotify.confirm(confirmUpdatePartnerState, {
        backdrop: 0.3,
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button' },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => this.processUpdatePartnerState(toast, id, state),
          },
        ],
      });
    },
    processUpdatePartnerState(toast, id, state) {
      this.$snotify.remove(toast.id);
      this.loading = true;

      partnerAPI.updatePartnerState(id, state).then(() => {
        this.getTier2Partner();
        this.$snotify.success(this.successUpdateStateMessage);
        this.loading = false;
        setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
      });
    },
  },
};
</script>

<style>
.partner-button-wrapper {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  gap: 1em;
}

@media (max-width: 960px) {
  .partner-button-wrapper {
    justify-content: start;
  }
}
</style>
